<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col>
          <span class="headline">{{ facilitator.title }}</span>
        </v-col>

        <authorization
          permissionKey="configuration_facilitator_medical_request_item"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col v-if="authorization" cols="auto">
            <v-dialog v-model="facilitatorDialog" max-width="900">
              <template v-slot:activator="{ on }">
                <v-btn color="light-blue" block dark v-on="on">
                  <v-icon class="mr-1" small>eva-edit-outline</v-icon>
                  Editar
                </v-btn>
              </template>

              <v-lazy v-model="facilitatorDialog">
                <MedicalRequestItemFacilitatorForm
                  :facilitator="facilitator"
                  @close="closeFacilitatorDialog"
                  @refresh="$emit('refresh')"
              /></v-lazy>
            </v-dialog>
          </v-col>
        </authorization>

        <authorization
          permissionKey="configuration_facilitator_medical_request_item"
          can="delete"
          v-slot:default="{ authorization }"
        >
          <v-col v-if="authorization" cols="auto">
            <v-btn color="red" block dark @click="deleteFacilitator">
              <v-icon class="mr-1" small>eva-trash-outline</v-icon>
              Excluir
            </v-btn>
          </v-col>
        </authorization>
      </v-row>
    </v-card-title>
    <v-card-text>
      <MedicalRequestItemFacilitatorItemTable
        :facilitatorItems="facilitator.items"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import DELETE_MEDICAL_REQUEST_ITEM_FACILITATOR from "@/graphql/medical_request/delete_medical_request_item_facilitator.gql";

import MedicalRequestItemFacilitatorItemTable from "@/components/config/medical_request/item_facilitators/item_facilitator_item_table.vue";
import MedicalRequestItemFacilitatorForm from "@/components/config/medical_request/item_facilitators/item_facilitator_form.vue";

export default {
  name: "MedicalRequestItemFacilitatorCard",
  components: {
    MedicalRequestItemFacilitatorItemTable,
    MedicalRequestItemFacilitatorForm,
  },
  props: {
    facilitator: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      facilitatorDialog: false,
    };
  },
  methods: {
    closeFacilitatorDialog() {
      this.facilitatorDialog = false;
    },
    async deleteFacilitator() {
      if (!confirm("Você realmente deseja excluir este facilitador?")) {
        return;
      }

      await this.apolloMutate({
        mutation: DELETE_MEDICAL_REQUEST_ITEM_FACILITATOR,
        variables: {
          medicalRequestItemFacilitatorId: this.facilitator.id,
        },
      });

      this.$emit("refresh");
    },
  },
};
</script>

<style scoped></style>
